// import { createReducer, on } from '@ngrx/store';
// import * as ListActions from '../actions/list.actions';
// import { initialState } from '../models/list-state.model';

// export const listReducer = createReducer(

//     initialState,

//     on(ListActions.saveListState, (state, action) => ({

//         ...state,

//         lists: {

//             ...state.lists,

//             [action.pageKey]: action.state

//         }

//     })),
//       on(ListActions.clearListState, (state, action) => {

//     const lists = { ...state.lists };

//     delete lists[action.pageKey];

//     return {
//       ...state,
//       lists
//     };

//   })



// );

import { Action, createReducer, on } from '@ngrx/store';
import * as ListActions from '../actions/list.actions';
import { initialState } from '../models/list-state.model';

const reducer = createReducer(

    initialState,

    on(ListActions.saveListState, (state, action) => ({
        ...state,
        lists: {
            ...state.lists,
            [action.pageKey]: action.state
        }
    })),

    on(ListActions.clearListState, (state, action) => {

        const lists = { ...state.lists };

        delete lists[action.pageKey];

        return {
            ...state,
            lists
        };
    })
);

export function listReducer(state: any, action: Action) {
    return reducer(state, action);
}